'use strict';

const angular = require('angular');

const EventList = require('./controllers/EventList');
const Calendar = require('./controllers/Calendar');
const PerformanceList = require('./controllers/PerformanceList');
const NewsSignup = require('./controllers/NewsSignup');
const TicketInfo = require('./controllers/TicketInfo');
const ToolBar = require('./controllers/ToolBar');
const MembershipPopup = require('./controllers/MembershipPopup');
const RecommendedEvents = require('./controllers/RecommendedEvents');
const FoodAndDrinks = require('./controllers/FoodAndDrinks');

angular
    .module('app.controllers', [])
    .controller('EventList', EventList)
    .controller('Calendar', Calendar)
    .controller('PerformanceList', PerformanceList)
    .controller('NewsSignup', NewsSignup)
    .controller('TicketInfo', TicketInfo)
    .controller('ToolBar', ToolBar)
    .controller('MembershipPopup', MembershipPopup)
    .controller('FoodAndDrinks', FoodAndDrinks)
    .controller('RecommendedEvents', RecommendedEvents);



// WEBPACK FOOTER //
// ./widgets/controllers.js